import { notification } from "antd";

import {
  GET_OFFER_REQUESTS,
  IS_LOADING_SAVE,
  GET_OFFER_REQUEST_BY_ID,
} from "./types";
import {
  SPremiumAuthorizedApiService,
  SPremiumAuthorizedFormApiService,
} from "../../../services/apiServices";
import { mapDataRows } from "../../../helpers/mapDataRows";
import { NavigationPath } from "../../../helpers/constants";

const setLoadingSave = (loading) => ({
  type: IS_LOADING_SAVE,
  payload: loading,
});

export const addRequest = (file, request, navigate) => async (dispatch) => {
  dispatch(setLoadingSave(true));

  const formData = new FormData();

  request.name && formData.append("name", request.name);
  formData.append("client", request.client);
  formData.append("IDNumber", request.IDNumber);
  formData.append("address", request.address);
  formData.append("phoneNumber", request.phoneNumber);
  request.scopeOfCoverage &&
    formData.append("scopeOfCoverage", request.scopeOfCoverage);
  request.note && formData.append("note", request.note);
  formData.append("file", file);

  SPremiumAuthorizedFormApiService.post("/offer-request", formData)
    .then((res) => {
      const { status } = res;

      if (status !== 201) {
        notification.error({
          message: "Something went wrong!",
        });
        return;
      }
      notification.success({
        message: "Offer request added!",
      });
      navigate(NavigationPath.OFFER_REQUESTS_ROUTE);
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong!",
      });
    })
    .finally(() => {
      dispatch(setLoadingSave(false));
    });
};

export const getOfferRequests = () => async (dispatch) => {
  SPremiumAuthorizedApiService.get("/offer-request")
    .then((res) => {
      const { status, data } = res;
      if (status !== 200) {
        notification.error({
          message: "Something went wrong, can not get offer requests",
        });
        return;
      }

      const offerRequests = mapDataRows(data.rows);

      dispatch({
        type: GET_OFFER_REQUESTS,
        payload: offerRequests,
      });
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong",
      });
    });
};

export const getRequestById = (id) => async (dispatch) => {
  dispatch({
    type: GET_OFFER_REQUEST_BY_ID,
    payload: null,
  });
  SPremiumAuthorizedApiService.get(`offer-request/${id}`)
    .then((res) => {
      const { status, data } = res;

      if (status !== 200) {
        notification.error({
          message: "Can not get offer request!",
        });
        return;
      }

      dispatch({
        type: GET_OFFER_REQUEST_BY_ID,
        payload: data,
      });
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong",
      });
    });
};

export const deleteOfferRequest = (ids) => async (dispatch) => {
  SPremiumAuthorizedApiService.delete(`/offer-request/`, {
    data: { ids },
  })
    .then((res) => {
      const { status } = res;

      if (status !== 204) {
        notification.error({
          message: "Something went wrong",
        });
        return;
      }
      notification.success({
        message:
          ids.length === 1 ? "Offer request deleted" : "Offer requests deleted",
      });
      getOfferRequests()(dispatch);
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong",
      });
    });
};
